import { InspectionResult } from '../api/ariadne/__generated_types__/graphql';

export const INSPECTION_SUCCESS_STATUS = 'success';
export const INSPECTION_FAILED_STATUS = 'fail';

export enum InspectionQuestionResult {
  NOT_STARTED = 'Not Started',
  INCOMPLETE = 'Incomplete',
  IN_PROGRESS = 'In Progress',
  NEEDS_CORRECTION = 'Needs Correction',
  PASS = 'pass',
  FAIL = 'fail',
}

// String constants that will be displayed in the HTML
export const INSPECTION_BOOKED = 'Inspection Booked';

export const InspectionText: Record<InspectionResult, string> = {
  [InspectionResult.Fail]: 'Fail',
  [InspectionResult.InProgress]: 'In Progress',
  [InspectionResult.Success]: 'Success',
};

export const InspectionColor: Record<InspectionResult, string> = {
  [InspectionResult.Fail]: 'red',
  [InspectionResult.InProgress]: 'blue',
  [InspectionResult.Success]: 'green',
};

export const InspectionResultColor: Record<InspectionQuestionResult, string> = {
  [InspectionQuestionResult.INCOMPLETE]: 'darksalmon',
  [InspectionQuestionResult.NEEDS_CORRECTION]: 'darksalmon',
  [InspectionQuestionResult.PASS]: 'green',
  [InspectionQuestionResult.FAIL]: 'red',
  [InspectionQuestionResult.NOT_STARTED]: 'black',
  [InspectionQuestionResult.IN_PROGRESS]: 'black',
};
